/**
 * Status tabs for the list-detail Leads view. Extracted from `Unassigned.tsx` so the tab-count
 * chips ({@link ./TabCountChips}) can share the enum without a circular import.
 */
export enum Tabs {
	UNASSIGNED = "UNASSIGNED",
	SAVED_FOR_LATER = "SAVED_FOR_LATER",
	ASSIGNED = "ASSIGNED",
	ARCHIVED = "ARCHIVED",
	UNDER_REVIEW = "UNDER_REVIEW",
	TRACKED_PROFILE = "TRACKED_PROFILE",
	/** Company-only lists (PREC-4400): the companies waiting for a bulk Find person. */
	COMPANIES = "COMPANIES",
}
